var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',{staticClass:"auth-main color-1"},[_c('router-view'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }